import LayoutConfig from 'app/config/layout/LayoutConfig';
import DialogSelectPlatform from 'app/modules/components/dialogs/DialogSelectPlatform/DialogSelectPlatform';
import AuthView from 'core/lite/views/AuthView/AuthView';
import { isTeams } from 'core/utils/teamsTab';
import React from 'react';
import MSTeamsTab from '../MSTeamsTab';
import useLoginPage from './useLoginPage';

const LoginPage = () => {
  const { legal, privacy, shouldShowPlatformDialog } = useLoginPage();

  return (
    <>
      {isTeams() && <MSTeamsTab />}
      {!isTeams() && (
        <>
          {shouldShowPlatformDialog && <DialogSelectPlatform />}
          <AuthView form="login" showSignup={LayoutConfig.login.showSignup} legal={legal} privacy={privacy} />
        </>
      )}
    </>
  );
};

export default LoginPage;
